import usePost from './usePost'
import useCurrent from './useCurrent';
import useFetch from './useFetch';

const useLogs = () => {
    const rawUrl = process.env.REACT_APP_LOGS_API_BASE_URL;
    const _url = (() => {
        if (process.env.NODE_ENV !== 'development') {
            return rawUrl;
        }

        if (!rawUrl) {
            return '/logs';
        }

        if (rawUrl.startsWith('/')) {
            return rawUrl;
        }

        try {
            const parsed = new URL(rawUrl);
            return parsed.pathname.replace(/\/$/, '');
        } catch {
            return rawUrl;
        }
    })();
    // إيقاف ريكوستات الـ logs مؤقتًا لأن خدمة logs ترجع 502 على api.absat-erp.com/logs
    const shouldSkipLogs = true;
    const {data:resultLogsPost,loading:loadingLogsPost,error:errorLogsPost,postData} = usePost();
    const {currentTenantId,currentCompany,currentBranchId,userId,userName} = useCurrent();
    const logsUrl = !shouldSkipLogs && _url && currentTenantId ? `${_url}/${currentTenantId}` : null;
    const {data:resultLogsFetch,loading:loadingLogsFetch,error:errorLogsFetch} = useFetch(logsUrl);

    const postDataHandler = async({moduleName,resourceName,eventName,logContentEn,logContentAr}) => {
        if (shouldSkipLogs || !_url || !currentTenantId) return;
        const _data = {
            appId: "000000",
            tenantId: currentTenantId,
            companyId: currentCompany,
            branchId: currentBranchId,
            userId:userId,
            userName: userName,
            moduleName: moduleName,
            resourceName: resourceName,
            eventName:eventName,
            logContentEn: logContentEn,
            logContentAr: logContentAr
        }
        await postData(_url,_data)
    }

    return {
        resultLogsPost,
        loadingLogsPost,
        errorLogsPost,
        postDataHandler,
        resultLogsFetch,
        loadingLogsFetch,
        errorLogsFetch
    }
}

export default useLogs
